import React from "react";
import { useTranslation } from "react-i18next";
import type ConstructionListItem from "../../types/ConstructionListItem";
import useEditConstructionsNewDialogHook from "./hooks/useEditConstructionsNewDialogHook";
import IsaacDialog from "../../../../components/isaacDialog/IsaacDialog";
import styles from "./editConstructionsNewDialog.module.scss";
import { ComboBox, DefaultButton, DialogFooter, DialogType, Position, PrimaryButton, SpinButton } from "@fluentui/react";

interface EditConstructionsNewDialogProps {
  isOpen: boolean;
  selectedConstructions: ConstructionListItem[];
  onDismiss: () => void;
}

const EditConstructionsNewDialog: React.FC<EditConstructionsNewDialogProps> = (
    { isOpen, selectedConstructions, onDismiss }) => {
    const {t} = useTranslation(["common"]);
    const {
        error,
        loading,
        formData,
        constructionLocationCodes,
        constructionLocationTypes,
        handleConfirm,
        handleDismiss,
        handleComboBoxChange,
        handleNumericFieldChange,
    } = useEditConstructionsNewDialogHook({onDismiss, selectedConstructions});

    return (
        <IsaacDialog
            isLoading={loading}
            isHidden={!isOpen}
            successMessage={error}
            error={error}
            modalProps={{
                titleAriaId: "BulkEdit",
                subtitleAriaId: "myBulkTextId",
                containerClassName: `ms-dialogMainOverride ${styles.container}`,
            }}
            dialogContentProps={{
                type: DialogType.normal,
                title: t("editingDialogTitle"),
            }}
            handleDialogDismiss={handleDismiss}>
            <form onSubmit={handleConfirm} id="edit-form">
                <SpinButton
                  id="phase"
                  onChange={handleNumericFieldChange}
                  labelPosition={Position.top}
                  label={t("labelConstructionPhase")}
                  defaultValue={formData.phase?.toString() ?? ""}
                  step={1}
                />
                <ComboBox
                  id="locationCode"
                  label={t("labelConstructionCode")}
                  defaultSelectedKey={formData?.locationCode}
                  onChange={handleComboBoxChange}
                  options={constructionLocationCodes ?? []}
                  className={styles.code}
                  allowFreeform={false}
                  autoComplete="on"
                  dropdownWidth={100}
                  allowFreeInput
                  required
                />
                <ComboBox
                  id="locationType"
                  label={t("labelConstructionType")}
                  defaultSelectedKey={formData?.locationType}
                  onChange={handleComboBoxChange}
                  options={constructionLocationTypes ?? []}
                  className={styles.code}
                  allowFreeform={false}
                  autoComplete="on"
                  dropdownWidth={100}
                  allowFreeInput
                  required
                />
            </form>
            <DialogFooter>
                <PrimaryButton text={t("confirm")} type="submit" form="edit-form" />
                <DefaultButton onClick={handleDismiss} text={t("cancel")} />
            </DialogFooter>
        </IsaacDialog>
  );
};

export default EditConstructionsNewDialog;




